import {createRouter, createWebHashHistory} from 'vue-router';

import Index from '@/modules/vue/pages/Index.vue';

const routes = [
  {
    name: 'index',
    path: '/index',
    component: Index,
    meta: {
      title: 'Vite + Vue + TypeScript + Tailwind Starter Template',
    },
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
